const gender = {
  0: "男",
  1: "女",
};

const leftRightHand = {
  0: "右手",
  1: "左手",
  2: "双手",
};

const bowlerKickType = {
  0: "直线",
  1: "曲线",
  2: "飞碟",
};

export default {
  gender,
  leftRightHand,
  bowlerKickType,
};
